// extracted by mini-css-extract-plugin
export var paginationContainer = "_68-0";